import { render, staticRenderFns } from "./PdvUserPaymentDashboard.vue?vue&type=template&id=cfdd20ee"
import script from "./PdvUserPaymentDashboard.vue?vue&type=script&lang=js"
export * from "./PdvUserPaymentDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports